namespace appn.views.users.map {
    class InitArgs {
        userGroups: Array<SelectListItem> = [];
        usersFilter: Array<AppnSelectListItem> = [];
        userLatLng: string = emptyString;
        userHasDataEntryAccess: boolean = false;
        dateFilter: string = emptyString;
        usersEdit: string = emptyString;
        usersMapData: string = emptyString;
    }

    let _initArgs: InitArgs;
    let _historyEnabled: boolean;
    let _pagingToolbar: PagingToolbar;
    let _mapMain: any;
    let _users: Array<UserMapDetail>;
    let _topPopupContent: string = emptyString;
    let _isTop: boolean = true; 

    export function init(args: InitArgs): void {
        _initArgs = args;

        createPagingToolbar();
        createMapMain();
        addEvents();
    }

    appn.pubSub.subscribe(appn.pubSub.WINDOW_RESIZED, function(channel: string, data: any) {
        if (!_mapMain || !_mapMain.map)
            return;

        (_mapMain.map as L.Map).invalidateSize();
    });
    
    function addEvents() {
        appn.dialog.showLoading();
        appn.dateFilter.init(_initArgs.dateFilter);

        $('.users-legend .acc-collapse-button').on('click', function() {
            if ($(this).hasClass('collapsed')) {
                $(this).find('.fa.fa-chevron-up').show();
                $(this).find('.fa.fa-chevron-down').hide();
            } else {
                $(this).find('.fa.fa-chevron-up').hide();
                $(this).find('.fa.fa-chevron-down').show();
            }
        });

        // Get auto generate color classes
        _mapMain.usersColorClasses = [];
        $('.users-legend ul li').each(function(i: number, item: HTMLElement) {
            const colorClasses = $(item)?.attr('class')?.split(' ') ?? [];

            colorClasses.forEach(function(colorClass: string, index: number): void {
                if (colorClass.contains('color-brand-'))
                    _mapMain.usersColorClasses.push({ userId: $(item).prop('id'), colorClass: colorClass });
            });
        });

        _mapMain.setColorBy(appn.emptyString);

        $('#ColorByUser').off().on('change', function() {
            _mapMain.setColorBy('users');
            _mapMain.getMapDataFromServer(true);
        });

        _pagingToolbar.init();

        _mapMain.getMapDataFromServer(true);
    }

    function createPagingToolbar(): void {
        _pagingToolbar = {
            init: function() {
                $('#GoPrevious').on('click', function() {
                    if (!appn.ui.isElementDisabled($('#GoPrevious'))) {
                        _pagingToolbar.pageNum--;
                        _mapMain.getMapDataFromServer();
                    }
                });

                $('#GoNext').on('click', function() {
                    if (!appn.ui.isElementDisabled($('#GoNext'))) {
                        _pagingToolbar.pageNum++;
                        _mapMain.getMapDataFromServer();
                    }
                });
            },
            pageSize: 100,
            pageNum: 1,
            totalUsers: 0,
            updateUi: function() {
                let totalText = T('No results found');

                if (_pagingToolbar.totalUsers > 0) {
                    const totalRecs = _pagingToolbar.totalUsers;
                    const startRec = ((_pagingToolbar.pageSize * _pagingToolbar.pageNum) - _pagingToolbar.pageSize) + 1;
                    const lastRec = Math.min((_pagingToolbar.pageSize * _pagingToolbar.pageNum), totalRecs);

                    totalText = T('Showing {0} to {1} of {2} users', startRec, lastRec, totalRecs);
                }

                $('#TotalsText').html(totalText);

                if ((_pagingToolbar.pageSize * _pagingToolbar.pageNum) < _pagingToolbar.totalUsers)
                    appn.ui.enableElement($('#GoNext'));
                else
                    appn.ui.disableElement($('#GoNext'));

                if (_pagingToolbar.pageNum > 1)
                    appn.ui.enableElement($('#GoPrevious'));
                else
                    appn.ui.disableElement($('#GoPrevious'));

            }
        };
    }

    function createMapMain(): void {
        _mapMain = {
            map: appn.ui.mapInit('mapMain', 0, 0, 11, false) as L.Map,
            markersAdded: [],
            totalEntries: 0,
            totalUsers: 0,
            noLatLongEntries: 0,
            firstPopup: new L.Marker(new L.LatLng(0, 0)),
            locationsToRender: [],
            usersColorClasses: [],
            updateTotalEntries: function() {
                _mapMain.totalUsers = _pagingToolbar.totalUsers;

                let totalText = '<i class="fa fa-search text-danger"></i><span class="ml-2">' + T('No results found') + '</span>';
                if (_mapMain.totalEntries > 0)
                    totalText = T('<b>{0}</b> locations for <b>{1}</b> Users', _mapMain.totalEntries, _mapMain.totalUsers);

                const currentDateSelection = $('.appnDateFilter li.active .appnDateFilter-typeName').text();
                totalText += T(' for {0}', currentDateSelection.toLowerCase());
                $('.header-text .totalShowing').html(totalText);
            },
            removeMarkers: function() {
                // Remove each 'layer' with a marker in it.
                _mapMain.markersAdded.forEach((marker) => {
                    _mapMain.map.removeLayer(marker);
                    _mapMain.markersAdded = [];
                });
            },
            setColorBy: function(colorBy: string) {
                if (colorBy === appn.emptyString) {
                    colorBy = appn.localStorage.getItem('map_defaultColorBy');

                    if (!colorBy)
                        colorBy = 'users';
                }

                appn.localStorage.setItem('map_defaultColorBy', colorBy);

                if (colorBy === 'users')
                    $('#ColorByUser').prop('checked', true);
            },
            renderDataOnMap: function() {
                createMap_renderDataOnMap();
            },
            getMapDataFromServer: function() {
                
                createMap_getMapDataFromServer(true);

                _pagingToolbar.updateUi();
                _mapMain.updateTotalEntries();
            }
        };
    }

    function createMap_renderDataOnMap(): void {
        // Remove the existing markers ready for the new set being drawn
        _mapMain.removeMarkers();
        _mapMain.locationsToRender = [];
        _mapMain.firstPopup = new L.Marker(new L.LatLng(0, 0));
        const latlng = _initArgs.userLatLng.split(',');
        let firstEntryLatLng = new L.LatLng((latlng[0] as any), (latlng[1] as any));
        const bounds: Array<L.LatLng> = [];
        let mostRecentDate: Date = new Date(0); // Set the date to Epoch time as an initailiser
        let mostRecentLatLong: L.LatLng = new L.LatLng(0, 0, 1);
        let mostRecentPopup: L.Marker = new L.Marker(mostRecentLatLong);

        // --- USER MAP DATA ITEMS
        _users.forEach((user) => {
            // Set up the location marker details
            const markers = getMarkerData(user);

            // Populate the markers
            markers.forEach((marker) => {
                _mapMain.locationsToRender.push(marker);
            });
        });

        // Update location count
        _mapMain.totalEntries = _pagingToolbar.totalUsers;
        if (_historyEnabled)
            _mapMain.totalEntries = _mapMain.locationsToRender.length;

        // --- DRAW MARKER ON MAP
        const markers = L.markerClusterGroup();
        _mapMain.locationsToRender.forEach((locationToRender: LocationInfo, index: number) => {
            const lat = locationToRender.lat;
            const lon = locationToRender.lon;

            if (mostRecentDate === (new Date(0)))
                mostRecentDate = locationToRender.timeStamp;

            const newCoordinate = new L.LatLng(lat, lon, 1);
            bounds.push(newCoordinate);

            const pinColourClass = locationToRender.colorClass;
            const pinUserColor = locationToRender.userColorCode;
            let icon: L.DivIcon = new L.DivIcon();

            if ($('#ColorByUser').prop('checked') === true) {
                if (pinUserColor) {
                    let htmlPin = `<div class="appn-mapPin" opacity: 0.7;" style="background-color:${pinUserColor}; border-color:${pinUserColor};">`;
                    if (_historyEnabled)
                        htmlPin += `<div class="map-pin-number">${locationToRender.locationIndex + 1}</div>`;

                    htmlPin += `</div><div class="appn-mapShadow" style="background-color:${pinUserColor}; border-color:${pinUserColor};"></div>`;

                    icon = L.divIcon({
                        html: htmlPin,
                        className: 'dummy'
                    });
                } else {
                    let htmlPin = `<div class="appn-mapPin ${pinColourClass}" opacity: 0.7;">`;
                    if (_historyEnabled)
                        htmlPin += `<div class="map-pin-number">${locationToRender.locationIndex}</div>`;

                    htmlPin += `</div><div class="appn-mapShadow ${pinColourClass}"></div>`;

                    icon = L.divIcon({
                        html: htmlPin,
                        className: 'dummy'
                    });
                }
            }
            else {
                // Use class to color map pin
                let htmlPin = `<div class="appn-mapPin ${pinColourClass}">`;
                if (_historyEnabled)
                    htmlPin += `<div class="map-pin-number">${locationToRender.locationIndex + 1}</div>`;

                htmlPin += `</div><div class="appn-mapShadow ${pinColourClass}"></div>`;
                icon = L.divIcon({
                    html: htmlPin,
                    className: 'dummy'
                });
            }

            // Create marker and add layers
            const newMarker = new L.Marker(newCoordinate, { icon: icon });
            markers.addLayer(newMarker);

            let buttons = appn.emptyString;

            if (buttons.hasValue())
                buttons += '<br />';

            const popupText = `<div class="appnMapPopup" data-locationid="${locationToRender.id}_${index}">
                <h5>${locationToRender.title}</h5><span>
                <span><i class="fa fa-clock"></i> Seen ${locationToRender.locationTime}</span><br>
                <a class="btn btn-link btn-sm pb-0" href="${getDataUrl(locationToRender.id)}">${T('View User')}</a><br>
                <span class="text-muted leaflet-popup-gpsstring"><i class="fa fa-map-marker"></i> ${lat} ${lon}</span></div>`;

            const popup = newMarker.bindPopup(popupText).on('popupopen', function (popup: L.LeafletEvent) {
                ($('abbr.timeago') as any).timeago();
                // Compare to top popup
                _isTop = (popup as any).popup._content === _topPopupContent;
            });

            if (locationToRender.timeStamp > mostRecentDate) {
                mostRecentDate = locationToRender.timeStamp;
                mostRecentPopup = popup;
                mostRecentLatLong = newCoordinate;
                _topPopupContent = (mostRecentPopup as any)._popup._content;
            }
        });

        _mapMain.map.addLayer(markers);
        _mapMain.markersAdded.push(markers);
        _mapMain.firstPopup = mostRecentPopup;
        firstEntryLatLng = mostRecentLatLong;

        // Check for the latest entry here, verify that it is not an empty marker
        if (_mapMain.firstPopup.getLatLng().lat === firstEntryLatLng.lat &&
            _mapMain.firstPopup.getLatLng().lat !== 0 &&
            _mapMain.firstPopup.getLatLng().lng === firstEntryLatLng.lng &&
            _mapMain.firstPopup.getLatLng().lng !== 0)
            _mapMain.firstPopup.openPopup();

        if (bounds.length > 0)
            _mapMain.map.fitBounds(getMapBounds(bounds));
        else
            _mapMain.map.setView(new L.LatLng((latlng[0] as any), (latlng[1] as any)), 6);
    }

    /**
     * Get the map bounds from an array of markers on the map
     */
    function getMapBounds(latLngs: Array<L.LatLng>): L.LatLngBounds {
        const mapBounds = new L.LatLngBounds(latLngs[0], latLngs[0]);
        latLngs.forEach((point) => {
            mapBounds.extend(point);
        });

        return mapBounds;
    }

    /**
     * Returns all the map location points in an array to be displayed
     */
    function getMarkerData(user: UserMapDetail): Array<LocationInfo> {
        const mapPoints: Array<LocationInfo> = [];
        _mapMain.totalEntries = 0;

        if ($('#enableHistory').is(':checked'))
            _historyEnabled = true;

        const colorToAdd = appn.emptyString;
        let colorClassToAdd = appn.emptyString;

        if (user.MapLocationPoints.length > 0) {
            _pagingToolbar.totalUsers++;
            //  Get user colors
            if ($('#ColorByUser').prop('checked'))
                $(_mapMain.usersColorClasses).each(function(i: number, item: any) {
                    if (item.userId === user.ApiId) {
                        if (item.colorClass)
                            colorClassToAdd = item.colorClass;
                        return false;
                    }
                });

            // Set up list of locations, filtered in controller
            // With location history
            if (_historyEnabled)
                user.MapLocationPoints.forEach((mapLocationPoint, index) => {
                    const mapPoint = new LocationInfo(user.Id,
                        `${user.LastName}, ${user.FirstName}`,
                        colorToAdd,
                        colorClassToAdd,
                        index,
                        mapLocationPoint.Latitude,
                        mapLocationPoint.Longitude,
                        mapLocationPoint.TimeAgo,
                        new Date(Number(mapLocationPoint.TimeStamp) * 1000),
                        user.UserColorCode);

                    mapPoints.push(mapPoint);
                });

            // Only latest location
            if (!_historyEnabled) {
                const mapPoint = new LocationInfo(user.Id,
                    `${user.LastName}, ${user.FirstName}`,
                    colorToAdd,
                    colorClassToAdd,
                    0,
                    user.MapLocationPoints[0].Latitude,
                    user.MapLocationPoints[0].Longitude,
                    user.MapLocationPoints[0].TimeAgo,
                    new Date(Number(user.MapLocationPoints[0].TimeStamp) * 1000),
                    user.UserColorCode);

                mapPoints.push(mapPoint);
            }
        }

        return mapPoints;
    }

    function getDataUrl(userId: number) {
        return _initArgs.usersEdit + '/' + userId;
    }

    function createMap_getMapDataFromServer(resetPaging: boolean): void {
        appn.dialog.showLoading();

        // *** BUILD URL INC. FILTERS ***
        if (resetPaging)
            _pagingToolbar.pageNum = 1;

        // History filter
        _historyEnabled = appn.dataTable.getStateOrDefault('enableHistory', $('#enableHistory').is(':checked')).value;

        //  User Filter
        const userToFilterBy = appn.dataTable.getStateOrDefault('userFilter', $('#userFilter').val());
        if (!userToFilterBy.value || userToFilterBy.value === 'All')
            userToFilterBy.value = appn.emptyString;

        //  Date Filter
        const appnDateFilterValue = appn.dateFilter.getStateOrDefault();

        // Build full URL
        const params = appn.location.buildQueryString([
            { name: 'v', value: new Date().getTime() },
            { name: 'userFilterId', value: userToFilterBy.value },
            { name: 'dateFilter', value: appnDateFilterValue.type },
            { name: 'dateFilterFrom', value: encodeURIComponent(appnDateFilterValue.fromDate) },
            { name: 'dateFilterTo', value: encodeURIComponent(appnDateFilterValue.toDate) },
            { name: 'pageSize', value: _pagingToolbar.pageSize },
            { name: 'pageNum', value: (_pagingToolbar.pageNum - 1) }
        ]);

        // User Group Filter - Only added if userGroups contain values
        let userGroupFilterParam = appn.emptyString;
        if (_initArgs.userGroups.length > 0) {
            const userGroupToFilterBy = appn.dataTable.getStateOrDefault('userGroupFilter', $('#userGroupFilter').val());

            if (!userGroupToFilterBy.value || userGroupToFilterBy.value === 'All')
                userGroupToFilterBy.value = appn.emptyString;

            userGroupFilterParam = `&userGroupFilterId=${userGroupToFilterBy.value}`;
        }

        const url = _initArgs.usersMapData + params + userGroupFilterParam;

        appn.ajax.post({
            url: url,
            dataType: 'json',
            done: function(data: any): void {
                _users = data as Array<UserMapDetail>;
                _pagingToolbar.totalUsers = 0;
                getMapDataFromServerAjaxPostDone();
            },
            fail: function(): void {
                appn.dialog.alert({
                    modalColor: 'modal-danger',
                    title: T('Map Data Load Failed'),
                    message: T('Failed to load map data.  Please sign out and sign in again.  Contact support if this problem persists.'),
                    buttons: {
                        ok: {
                            label: '<span>' + T('OK') + '</span>',
                            className: 'btn-success'
                        }
                    },
                    autoHeaderIcon: false
                });
                appn.dialog.hideLoading();
            }
        });
    }

    function getMapDataFromServerAjaxPostDone() {
        _mapMain.renderDataOnMap();
        _pagingToolbar.updateUi();

        // Clear all filters
        $('.mapHeader .header-filters').html(emptyString);

        // Append filter button
        appn.sideFilterAndContent.appendShowButton($('.mapHeader .header-filters '));

        // Update UI with new user box
        $('.mapHeader .header-filters ').prepend(appn.elementBuilder.buildSelect(_initArgs.usersFilter, 'userFilter', 'saveMeState'));

        // Update user groups box
        if (_initArgs.userGroups.length > 0)
            $('.mapHeader .header-filters ').prepend(appn.elementBuilder.buildSelect(_initArgs.userGroups, 'userGroupFilter', 'saveMeState'));

        // Update Most Recent button
        if (_mapMain.locationsToRender.length > 0) {
            // Show Most Recent
            $('.mapHeader .header-filters ').prepend(`<button id="btnShowMostRecent" title="${T('Displays the popup for the most recent User Map Pin.')}" class="btn-sm btn btn-info ml-2">${T('Latest')}</button>`);

            $('#btnShowMostRecent').off().on('click', function(e: Event) {
                e.preventDefault();
                const shake = _isTop;
                _mapMain.firstPopup.openPopup();
                if (shake)
                    appn.utils.shake($((_mapMain.firstPopup as any)._popup._wrapper));
                
                ($('abbr.timeago') as any).timeago();
            });
        }

        // Show History
        $('.mapHeader .header-filters').prepend(appn.elementBuilder.buildCheckbox(T('Show History'), 'saveMeState', 'enableHistory'));

        appn.popover.init();

        appn.saveMeState.init(function() {
            _pagingToolbar.totalUsers = 0;
            _mapMain.getMapDataFromServer(true);
        },
            function() {
                _mapMain.setColorBy('users');
                _mapMain.getMapDataFromServer(true);
                _historyEnabled = false;
            }, '.mapHeader .header-filters ');

        _mapMain.updateTotalEntries();
        select.init();

        // Finished processing -> remove modal
        appn.dialog.hideLoading();
    }

    class UserMapDetail {
        Id: number = 0;
        ApiId: string = emptyGuid;
        DeviceCount: number = 0;
        Email: string = emptyString;
        ExternalId: string = emptyString;
        FirstName: string = emptyString;
        HasWebAccess: boolean = false;
        LastName: string = emptyString;
        LastUpdated: Date = new Date();
        Level: string = emptyString;
        LocationHistory: Array<GeoPosition> = [];
        MapLocationPoints: Array<GeoPosition> = [];
        Status: UserStatus = UserStatus.Inactive;
        Type: UserType = UserType.Standard;
        UserColorCode: string = emptyString;
    }

    class LocationInfo {
        constructor(id: number, title: string, color: string, colorClass: string, locationIndex: number, lat: number, lon: number, locationTime: string, timeStamp: Date, userColorCode: string) {
            this.id = id;

            if (title.hasValue())
                this.title = title;

            this.color = color;
            this.colorClass = colorClass;
            this.locationIndex = locationIndex;
            this.lat = lat;
            this.lon = lon;
            this.locationTime = locationTime;
            this.timeStamp = timeStamp;
            this.userColorCode = userColorCode;
        }

        id: number = 0;
        title: string = T('Unknown User');
        color: string = emptyString;
        colorClass: string = emptyString;
        locationIndex: number = -1;
        lat: number = 0;
        lon: number = 0;
        locationTime: string = emptyString;
        timeStamp: Date = new Date(0);
        userColorCode: string = emptyString;
    }

  

    interface UserColorClass {
        userId: string;
        colorClass: string;
    }
}
